import { render, staticRenderFns } from "./BroadcastFormBanner.vue?vue&type=template&id=c997ff36&scoped=true&"
import script from "./BroadcastFormBanner.vue?vue&type=script&lang=ts&"
export * from "./BroadcastFormBanner.vue?vue&type=script&lang=ts&"
import style0 from "./BroadcastFormBanner.vue?vue&type=style&index=0&id=c997ff36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c997ff36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VRow})
